import { ReactComponent as Peso } from "../../../../assets/newIcons/OBJ-PESO.svg";
import MejoraDelRendimientoFisico from "../../../../assets/habits/MEJORA_DEL_RENDIMIENTO_FISICO.svg";
import ControlOptimizacionRecuperacion from "../../../../assets/habits/CONTROL_OPTIMIZACION_RECUPERACION.svg";
import ControlYMejoraEnfermedadesCronicas from "../../../../assets/habits/CONTROL_Y_MEJORA_ENFERMEDADES_CRONICAS.svg";
import DesarrolloIntegralDelDeportista from "../../../../assets/habits/DESARROLLO_INTEGRAL_DEL_DEPORTISTA.svg";
import MejoraComposicionCorporal from "../../../../assets/habits/MEJORA_COMPOSICION_CORPORAL.svg";
import MejoraDeHabilidadesTecnicas from "../../../../assets/habits/MEJORA_DE_HABILIDADES_TECNICAS.svg";
import OptimizacionMentalEmocional from "../../../../assets/habits/OPTIMIZACION_MENTAL_EMOCIONAL.svg";
import PrevencionYRecuperacionDeLesiones from "../../../../assets/habits/PREVENCION_Y_RECUPERACION_DE_LESIONES.svg";
import RendimientoEnCompetencias from "../../../../assets/habits/RENDIMIENTO_EN_COMPETENCIAS.svg";
import OptimizacionCarga from "../../../../assets/habits/OPTIMIZACION_CARGA.svg";
import MovilidadFlexibilidad from "../../../../assets/habits/MOVILIDAD_FLEXIBILIDAD.svg";
import ActividadesBajoImpacto from "../../../../assets/habits/ACTIVIDADES_BAJO_IMPACTO.svg";
import EntrenamientoCardiovascular from "../../../../assets/habits/ENTRENAMIENTO_CARDIOVASCULAR.svg";
import EntrenamientoFuerza from "../../../../assets/habits/ENTRENAMIENTO_FUERZA.svg";
import EntrenamientoFuncional from "../../../../assets/habits/ENTRENAMIENTO_FUNCIONAL.svg";
import EntrenamientoPotencia from "../../../../assets/habits/ENTRENAMIENTO_POTENCIA.svg";
import EntrenamientoRecuperacion from "../../../../assets/habits/ENTRENAMIENTO_RECUPERACION.svg";
import OtrosTipos from "../../../../assets/habits/OTROS.svg";
import YogaHabits from "../../../../assets/habits/YOGA.svg";
import CiclismoHabits from "../../../../assets/habits/CICLISMO.svg";
import Baseball from "../../../../assets/corporative/icon-sports/ic_baseball_selected.png";
import Basketball from "../../../../assets/corporative/icon-sports/ic_basketball_selected.png";
import Boxing from "../../../../assets/corporative/icon-sports/ic_boxing_selected.png";
import Cycling from "../../../../assets/corporative/icon-sports/ic_ciclysm_selected.png";
import Gimnastics from "../../../../assets/corporative/icon-sports/ic_gimnastics_selected.png";
import Golf from "../../../../assets/corporative/icon-sports/ic_golf_selected.png";
import Martial from "../../../../assets/corporative/icon-sports/ic_martial_arts_selected.png";
import Rugby from "../../../../assets/corporative/icon-sports/ic_rugby_selected.png";
import Otros from "../../../../assets/corporative/icon-sports/ic_salud_selected.png";
import Skating from "../../../../assets/corporative/icon-sports/ic_skate_selected.png";
import Tennis from "../../../../assets/corporative/icon-sports/ic_tennis_selected.png";
import Volleyball from "../../../../assets/corporative/icon-sports/ic_volleyball_selected.png";
import Yoga from "../../../../assets/corporative/icon-sports/ic_yoga_selected.png";
import Running from "../../../../assets/corporative/icon-sports/running.png";
import Swimming from "../../../../assets/corporative/icon-sports/swimming.png";
import Soccer from "../../../../assets/corporative/icon-sports/ic_soccer_selected.png";
import Bicicleta from "../../../../assets/habits/BICICLETA.svg";
import Carro from "../../../../assets/habits/VEHICULO_MOTORIZADO.svg";
import Caminar from "../../../../assets/habits/CAMINAR.svg";
import Bus from "../../../../assets/habits/VEHICULO_MOTORIZADO.svg";
import pressure from "../../../../assets/habits/PRESION_CONSTANTE.svg";
import patient from "../../../../assets/habits/PACIENTE_Y_CALMADO.svg";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useState } from "react";
import ModalInfo from "../modal-info";

const Step4Habits = ({ userDetail, showModal }) => {
  const transportation = userDetail?.funtional_history?.transportation || "";
  const guidance = userDetail?.funtional_history?.guidance || "";
  const objectives = userDetail?.funtional_history?.objectives || [];
  const activity_types = userDetail?.funtional_history?.activity_types || [];

  const transportationTypes = {
    1: {
      image: Carro,
      label: "Carro",
    },
    2: {
      image: Bicicleta,
      label: "Bicicleta",
    },
    3: {
      image: Bus,
      label: "Transporte público",
    },
    4: {
      image: Caminar,
      label: "Caminar",
    },
  };
  const habitos = [
    {
      name: "¿Cuáles son tus objetivos?",
      icon: RendimientoEnCompetencias,
      value: objectives,
      is_icon: true,
      is_vector: true,
      label: "objectives",
    },
    {
      name: "¿Realiza algún tipo de entrenamiento de acondicionamiento?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.conditioning_training ? "Sí" : "No",
      is_true_or_false: true,
    },
    {
      name: "Tipo de acompañamiento que prefiere del entrenador",
      icon: guidance == 1 ? pressure : patient,
      value: guidance == 1 ? "Presión constante" : "Paciente y calmado",
      is_icon: true,
    },
    {
      name: "¿Realizas actividad física en este momento?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.physical_active ? "Sí" : "No",
      is_true_or_false: true,
    },
    {
      name: "¿Qué tipo de actividad física realiza?",
      icon: RendimientoEnCompetencias,
      value: activity_types,
      is_icon: true,
      is_vector: true,
      label: "activity_types",
    },
    {
      name: "¿Cuántas veces a la semana hace actividad física a la semana?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.activity_per_week || "---",
    },
    {
      name: "¿Cuánto duran las sesiones que hace? ",
      icon: <Peso />,
      value: userDetail?.funtional_history?.activity_session || "---",
    },
    {
      name: "¿Cuál es el nivel de intensidad de las sesiones que hace?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.activity_intensity || "---",
    },
    {
      name: "¿Cúal es el nivel de cansancio?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.activity_fatigue_level || "---",
    },
    {
      name: "¿En que Franja horaria te gustaría tomar tus entrenamientos?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.training_time || "---",
    },
    {
      name: "¿Cuál medio de transporte usas diariamente?",
      icon: transportationTypes[transportation]?.image || Caminar,
      value: transportationTypes[transportation]?.label || "---",
      is_icon: true,
    },
    {
      name: "¿Cuánto tiempo duras en el medio de transporte?",
      icon: <Peso />,
      value: userDetail?.funtional_history?.transportation_time || "---",
    },
  ];

  const objectiveImages = {
    10: {
      image: MejoraComposicionCorporal,
      label: "Mejora de la composición corporal",
    },
    20: {
      image: DesarrolloIntegralDelDeportista,
      label: "Desarrollo integral del deportista",
    },
    30: {
      image: MejoraDeHabilidadesTecnicas,
      label: "Mejora de habilidades técnicas",
    },
    40: {
      image: OptimizacionCarga,
      label: "Optimización de la carga de entrenamiento",
    },
    50: {
      image: MejoraDelRendimientoFisico,
      label: "Mejora del rendimiento físico",
    },
    60: {
      image: PrevencionYRecuperacionDeLesiones,
      label: "Prevención y recuperación de lesiones",
    },
    70: {
      image: ControlYMejoraEnfermedadesCronicas,
      label: "Control y mejora de enfermedades crónicas",
    },
    80: {
      image: MejoraDelRendimientoFisico,
      label: "Mejora del rendimiento físico",
    },
    90: {
      image: RendimientoEnCompetencias,
      label: "Rendimiento en competencias",
    },
    100: {
      image: OptimizacionMentalEmocional,
      label: "Optimización mental y emocional",
    },
    110: {
      image: ControlOptimizacionRecuperacion,
      label: "Control y optimización de la recuperación",
    },
  };

  const habitImages = {
    1: {
      image: YogaHabits,
      label: "Yoga",
    },
    2: {
      image: EntrenamientoFuncional,
      label: "Entrenamiento funcional",
    },
    3: {
      image: Caminar,
      label: "Caminar / Correr",
    },
    4: {
      image: MovilidadFlexibilidad,
      label: "Rumba",
    },
    5: {
      image: CiclismoHabits,
      label: "Ciclismo",
    },
    6: {
      image: OtrosTipos,
      label: "Otros",
    },
    7: {
      image: EntrenamientoFuerza,
      label: "Entrenamiento de fuerza",
    },
    8: {
      image: EntrenamientoCardiovascular,
      label: "Entrenamiento cardiovascular",
    },
    9: {
      image: EntrenamientoPotencia,
      label: "Entrenamiento de potencia",
    },
    10: {
      image: MovilidadFlexibilidad,
      label: "Movilidad y flexibilidad",
    },
    11: {
      image: ActividadesBajoImpacto,
      label: "Actividad de bajo impacto",
    },
    12: {
      image: EntrenamientoRecuperacion,
      label: "Entrenamiento de recuperación",
    },
  };
  const getImageByItemId = (id, label) => {
    if (label === "objectives") {
      return objectiveImages[id].image || ControlOptimizacionRecuperacion;
    } else {
      return habitImages[id].image || EntrenamientoRecuperacion;
    }
  };
  const getLabelById = (id, label) => {
    if (label === "objectives") {
      return objectiveImages[id].label || ControlOptimizacionRecuperacion;
    } else {
      return habitImages[id].label || EntrenamientoRecuperacion;
    }
  };

  return (
    <>
      {habitos.length > 0 ? (
        <PerfectScrollbar className="flex-grow-1 px-2">
          {habitos.map((item, idx) => (
            <div
              key={idx}
              className={`d-flex ${
                item.is_true_or_false ? " flex-row  " : "flex-column "
              } p-2 align-items-center col-12 col-xl-10 mx-auto`}
            >
              {item.is_true_or_false ? (
                <>
                  <div
                    className="col-6 input_info_athlete mb-2 "
                    style={{ lineHeight: "1", textAlign: "left" }}
                  >
                    <span className="text-center">
                      <strong>{item.name}</strong>
                    </span>
                  </div>
                  <div
                    className="col-6 input_info_athlete mb-2 gap-2 d-flex justify-content-center align-items-center"
                    style={{ lineHeight: "1", textAlign: "center" }}
                  >
                    <button
                      style={{ minWidth: "2.5rem" }}
                      className={
                        item.value == "Sí"
                          ? "add_location"
                          : "add_location_icon_negative"
                      }
                    >
                      <strong>Sí</strong>
                    </button>
                    <button
                      style={{ minWidth: "2.5rem" }}
                      className={
                        item.value == "No"
                          ? "add_location"
                          : "add_location_icon_negative"
                      }
                    >
                      <strong>No</strong>
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="col-12 input_info_athlete mb-2 "
                    style={{ lineHeight: "1", textAlign: "center" }}
                  >
                    <span className="text-center">
                      <strong>{item.name}</strong>
                    </span>
                  </div>
                  <div
                    className="col-12 mx-auto input_info_athlete text-center  d-flex justify-content-center align-items-center"
                    style={{
                      lineHeight: "1",
                    }}
                  >
                    {item.is_vector ? (
                      <div className="many-icons-habits">
                        {item.value.map((itemV, idx) => (
                          <div className="wrapper-item">
                            <div className="circle">
                              <img
                                src={getImageByItemId(itemV.id, item.label)}
                                alt={itemV.name}
                                className="icon"
                              />
                            </div>
                            <p className="label">
                              {getLabelById(itemV.id, item.label)}
                            </p>
                          </div>
                        ))}
                      </div>
                    ) : item.is_icon ? (
                      <div className="wrapper-item">
                        <div className="circle">
                          <img
                            src={item.icon}
                            alt={item.name}
                            className="icon"
                          />
                        </div>
                        <p className="label">{item.value}</p>
                      </div>
                    ) : (
                      <div className="icon-objective-habit p-3">
                        <span
                          style={{
                            fontSize: "calc(.35rem + .2vw)",
                            color: "white",
                            flexWrap: "wrap",
                            fontWeight: "500",
                            textAlign: "center",
                          }}
                        >
                          {item.value}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
        </PerfectScrollbar>
      ) : (
        <div className="d-flex mx-1 my-2 align-items-center">
          <span
            className="text-objective-jus"
            style={{ fontSize: "calc(.4rem + .3vw)" }}
          >
            No tiene objetivos asignados
          </span>
        </div>
      )}
    </>
  );
};

export default Step4Habits;
